import React from "react";
import { Box, Typography } from "@mui/material";
import { roadmapSteps } from "./data/mockData";

const Impact: React.FC = () => {
  return (
    <Box
      component="section"
      id="impact"
      sx={{
        py: { xs: 10, md: 14 },
        bgcolor: "#7B4F3A", // match your brown background
        color: "white",
      }}
    >
      <Box
        sx={{
          maxWidth: 1280,
          mx: "auto",
          px: 3,
          textAlign: "center",
        }}
      >
        <Typography
          variant="h2"
          sx={{
            fontSize: { xs: "2rem", md: "2.8rem" },
            fontWeight: 400,
            mb: 10,
          }}
        >
          The Solar Roadmap
        </Typography>

        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", md: "repeat(4, 1fr)" },
            gap: { xs: 8, md: 6 },
            position: "relative",
          }}
        >
          {roadmapSteps.map((item, idx) => (
            <Box
              key={idx}
              sx={{
                position: "relative",
                px: 3,
              }}
            >
              {/* Step Number */}
              <Typography
                sx={{
                  fontSize: "4rem",
                  fontWeight: 800,
                  opacity: 0.15,
                  mb: 3,
                }}
              >
                {item.step}
              </Typography>

              {/* Title */}
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 600,
                  mb: 1.5,
                }}
              >
                {item.title}
              </Typography>

              {/* Description */}
              <Typography
                sx={{
                  color: "rgba(255,255,255,0.75)",
                  fontSize: "0.95rem",
                  lineHeight: 1.7,
                }}
              >
                {item.desc}
              </Typography>

              {/* Vertical Divider */}
              {idx < roadmapSteps.length - 1 && (
                <Box
                  sx={{
                    display: { xs: "none", md: "block" },
                    position: "absolute",
                    top: "50%",
                    right: 0,
                    transform: "translate(50%, -50%)",
                    width: "2px",
                    height: "120px",
                    bgcolor: "rgba(255,255,255,0.2)",
                  }}
                />
              )}
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default Impact;
